import React, { useEffect } from 'react';
import { useStore } from '../../../../../stores/root';
import styles from './styles.module.scss';

// props
import { IOrderResourceProps } from '../../../../../props/orders/order';
import { IVendorResourceShortProps } from '../../../../../props/data/vendors';
import { IOfferResourceProps } from '../../../../../props/offers';
import { TSelectedFilterKey } from '.';

// components
import { Checkbox, Stack, TextField } from '@fluentui/react';
import Text from '../../../../typography/text';
import Label from '../../../../typography/label';

type OrdersDashboardChartFilterVendorProps = {
    orders: IOrderResourceProps[];
    filteredOrders: IOrderResourceProps[];
    hideSearch?: boolean;
    onChange(key: TSelectedFilterKey, selected: IVendorResourceShortProps[]): void;
}

const getAllOrderVendors = (order: IOrderResourceProps) => {
    if (order.vendors) {
        return order.vendors;
    }

    const vendors: IVendorResourceShortProps[] = [];
    const addVendor = (v?: IVendorResourceShortProps) => {
        if (v && v.id && !vendors.find(existing => existing.id === v.id)) {
            vendors.push(v);
        }
    };

    (order.trucks || []).forEach(t => addVendor(t.truck?.vendor));

    if (order.offer) {
        const o = order.offer as IOfferResourceProps;
        const checkCosts = (costs?: any[]) => {
            (costs || []).forEach(c => addVendor(c.vendor));
        };
        checkCosts(o.additionalCosts);
        checkCosts(o.insuranceCosts);
        checkCosts(o.charteredShipCosts);
        checkCosts(o.originTruckingCosts);
        checkCosts(o.destinationTruckingCosts);
        checkCosts(o.loadingLabourCosts);
        checkCosts(o.unloadingLabourCosts);
        checkCosts(o.containerShippingCosts);
    }

    return vendors;
};

const OrdersDashboardChartFilterVendor: React.FC<OrdersDashboardChartFilterVendorProps> = (props: OrdersDashboardChartFilterVendorProps) => {
    const { banner } = useStore();
    const [keyword, setKeyword] = React.useState<string>("");
    const [selected, setSelected] = React.useState<IVendorResourceShortProps[]>([]);

    useEffect(() => {

    }, [props.orders]);

    const getUniqueVendors = (): IVendorResourceShortProps[] => {
        const vendors: IVendorResourceShortProps[] = [];

        props.orders.forEach((order) => {
            const orderVendors = getAllOrderVendors(order);
            orderVendors.forEach((vendor) => {
                const exist = vendors.find((v) => v.id === vendor.id);
                if (!exist) {
                    vendors.push(vendor);
                }
            });
        });

        return vendors;
    }

    const renderOption = (vendor: IVendorResourceShortProps) => {
        const isChecked = selected.findIndex((s) => s.id === vendor.id) > -1;
        const totalItems = props.filteredOrders.filter((o) => {
            const allVendors = getAllOrderVendors(o);
            return allVendors.some(v => v.id === vendor.id);
        }).length;

        return <Checkbox key={vendor.id} onChange={(ev, checked) => onChange(!checked, vendor)} checked={isChecked} onRenderLabel={() => {
            return <Stack styles={{root: {marginTop: 3, marginLeft: 5}}}>
                <Text size={'small'}>{vendor.name} ({totalItems})</Text>
            </Stack>
        }} />
    }

    const onChange = (checked: boolean | undefined, vendor: IVendorResourceShortProps) => {
        let _selected = selected;
        if (checked) {
            _selected = _selected.filter((s) => s.id !== vendor.id);
        } else {
            _selected.push(vendor);
        }

        setSelected([..._selected]);
        props.onChange('vendor', _selected);
    }

    const uniqueVendors = getUniqueVendors();

    return <Stack className={styles.container} tokens={{childrenGap: 10}}>
        <Label size={"small"}>Vendors</Label>
        {props.hideSearch || uniqueVendors.length <= 5 ? null : <TextField iconProps={{iconName: "Search"}}
            placeholder={'Search vendor ...'}
            value={keyword}
            onChange={(ev, value) => setKeyword(value || "")} />}
        <Stack className={styles.options} tokens={{childrenGap: 8}}>
            {uniqueVendors.filter((c) => c.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1).map((vendor) => {
                return renderOption(vendor);
            })}
        </Stack>
    </Stack>;
};

export default OrdersDashboardChartFilterVendor;
